<div class="h-full overflow-hidden relative">
  <!-- Main content - shifts when panel opens -->
  <div class="h-full overflow-y-auto transition-[margin-right] duration-300"
       [style.margin-right]="sidePanelOpen ? '580px' : '0'">

<form [formGroup]="fieldAdminFieldsForm">

  <!-- Toolbar -->
  <div class="flex items-center gap-2.5 py-3.5 px-7 flex-wrap">
    <!-- Search -->
    <div class="relative">
      <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
      <input type="text" placeholder="Search..." (keyup)="search($event.target.value)"
        class="py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] text-[var(--base-text-alt-dark)] focus:border-[var(--primary-dark)] placeholder:text-[var(--base-text-alt-dark)]">
    </div>

    <!-- Active Season Filter -->
    <div class="relative z-[110]" #seasonStatusDropdown>
      <div (click)="showSeasonStatusMenu = !showSeasonStatusMenu; $event.stopPropagation()"
        class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">filter_list</span>
        <span>{{filterStatus?.description || 'All'}}</span>
        <span class="material-icons text-[16px]">expand_more</span>
      </div>
      <div *ngIf="showSeasonStatusMenu"
        class="absolute top-[calc(100%+4px)] left-0 min-w-[160px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200]">
        <div *ngFor="let status of activeSeasonStatus"
          (click)="setActiveSeasonStatus(status); showSeasonStatusMenu = false"
          class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)]"
          [class.font-semibold]="status.id === filterStatus?.id">
          {{status.description}}
        </div>
      </div>
    </div>

    <!-- Farm Filter -->
    <div class="relative z-[110]" #farmDropdown>
      <div (click)="showFarmMenu = !showFarmMenu; $event.stopPropagation()"
        class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
        <span class="material-icons text-[16px]">filter_list</span>
        <span>{{farmFilter?.name || 'Filter By Farm'}}</span>
        <span class="material-icons text-[16px]">expand_more</span>
      </div>
      <div *ngIf="showFarmMenu"
        class="absolute top-[calc(100%+4px)] right-0 min-w-[200px] max-h-[240px] overflow-y-auto bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[200]">
        <div *ngFor="let farm of farmList"
          (click)="setActiveFarmFilter(farm); showFarmMenu = false"
          class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)]"
          [class.font-semibold]="farm.id === farmFilter?.id">
          {{farm.name}}
        </div>
      </div>
    </div>

    <!-- Clear Filters -->
    <button *ngIf="isFilterBtnVisible" (click)="resetFilter()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span class="material-icons text-[16px]">filter_alt_off</span> Clear Filters
    </button>

    <div class="flex-1"></div>
  </div>

</form>

<!-- Table -->
<div class="px-7 overflow-y-auto" style="height: calc(100vh - 260px);">
  <table mat-table [dataSource]="dataSource" class="w-full border-collapse">

    <ng-container matColumnDef="farmName">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Farm Name</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.farmName ?? placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="fieldName">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Field Name</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element?.fieldName ?? placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="sizeHA">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Size(HA)</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element?.size ? (element.size | number:'1.2-2') : placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="inSeason">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">In Season</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-medium !text-[var(--base-text-alt-dark)] !border-b !border-[var(--app-base)]">{{element ? (element.inSeason ? activeSeasonYES : activeSeasonNO) : placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef="seasonName">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !text-[11px] !font-bold !uppercase !tracking-wider !text-[var(--tertiary-text)] !bg-[var(--app-base)] !text-left !whitespace-nowrap !border-b !border-[var(--app-base)]">Season Name</th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !text-[13px] !font-normal !text-[var(--tertiary-text)] !border-b !border-[var(--app-base)]">{{element?.seasonName ?? placeholder}}</td>
    </ng-container>

    <ng-container matColumnDef=" ">
      <th mat-header-cell *matHeaderCellDef class="!py-1 !px-3.5 !bg-[var(--app-base)] !border-b !border-[var(--app-base)]"></th>
      <td mat-cell *matCellDef="let element" class="!py-0.5 !px-3.5 !border-b !border-[var(--app-base)]">
        <span class="material-icons text-[18px] text-[var(--tertiary-text)] cursor-pointer hover:text-[var(--primary-dark)]"
          [class.opacity-40]="cultivarSizeInvalid && selectedFieldId !== element.fieldId"
          [class.pointer-events-none]="cultivarSizeInvalid && selectedFieldId !== element.fieldId"
          (click)="viewField(element)">chevron_right</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: auto; min-height: unset"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      class="transition-colors !h-auto cursor-pointer"
      [class.row-selected]="selectedFieldId === row.fieldId"
      [class.opacity-40]="cultivarSizeInvalid && selectedFieldId !== row.fieldId"
      [class.pointer-events-none]="cultivarSizeInvalid && selectedFieldId !== row.fieldId"
      [title]="cultivarSizeInvalid && selectedFieldId !== row.fieldId ? 'Fix the cultivar size before selecting another field' : ''"
      style="height: auto; min-height: unset"
      (click)="viewField(row)"></tr>
  </table>

  <div *ngIf="isNoItemsFound" class="flex items-center justify-center text-[var(--tertiary-text)] text-[13px] py-20">
    Sorry! No items found within the selected filter range.
  </div>
</div>

<!-- Paginator -->
<div class="flex items-center justify-end py-3.5 px-7 gap-4 border-t border-[var(--app-base)]">
  <span class="text-[12px] text-[var(--tertiary-text)] font-medium">Items per page:</span>
  <div class="relative" #pageSizeDropdown>
    <div (click)="showPageSizeMenu = !showPageSizeMenu; $event.stopPropagation()"
      class="py-2 px-3.5 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer flex items-center gap-1.5 hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      <span>{{pageSize}}</span>
      <span class="material-icons text-[16px]">expand_more</span>
    </div>
    <div *ngIf="showPageSizeMenu"
      class="absolute bottom-[calc(100%+4px)] left-0 min-w-[80px] bg-white rounded-[10px] shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] py-1 z-[100]">
      <div *ngFor="let size of [5, 10, 25]"
        (click)="onPageSizeChange(size)"
        class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer transition-colors hover:bg-[var(--app-base)]"
        [class.font-semibold]="size === pageSize">
        {{size}}
      </div>
    </div>
  </div>
  <span class="text-[13px] text-[var(--base-text-alt-dark)] font-medium">{{currentPage * pageSize + 1}} – {{min((currentPage + 1) * pageSize, totalElements)}} of {{totalElements}}</span>
  <div class="flex gap-1">
    <button (click)="goToPage(0)" [disabled]="currentPage === 0"
      class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
      <span class="material-icons text-[16px]">first_page</span>
    </button>
    <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0"
      class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
      <span class="material-icons text-[16px]">chevron_left</span>
    </button>
    <button (click)="goToPage(currentPage + 1)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
      class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
      <span class="material-icons text-[16px]">chevron_right</span>
    </button>
    <button (click)="goToPage(lastPage)" [disabled]="(currentPage + 1) * pageSize >= totalElements"
      class="w-8 h-8 border-[1.5px] border-[var(--app-border)] rounded-lg flex items-center justify-center cursor-pointer bg-white text-[var(--base-text-alt-dark)] hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] disabled:opacity-30 disabled:cursor-default disabled:hover:border-[var(--app-border)] disabled:hover:text-[var(--base-text-alt-dark)] transition-all">
      <span class="material-icons text-[16px]">last_page</span>
    </button>
  </div>
</div>

  </div><!-- end main content wrapper -->

  <!-- Side Panel -->
  <div class="fixed right-0 top-[56px] bottom-0 w-[580px] bg-white shadow-[-4px_0_20px_rgba(0,0,0,0.08)] z-[850] transition-transform duration-300 flex flex-col overflow-hidden"
       [class.translate-x-full]="!sidePanelOpen"
       [class.translate-x-0]="sidePanelOpen">
    <!-- Panel Header -->
    <div class="border-t-[3px] border-t-[var(--primary-dark)]">
      <div class="flex items-center gap-2 py-3 px-5 border-b border-[var(--app-base)]">
        <span class="text-[14px] font-bold flex-1 text-[var(--base-text-dark)]">{{selectedFieldName || 'Field Details'}}</span>
        <span class="material-icons cursor-pointer text-[var(--tertiary-text)] text-[20px] rounded-full w-7 h-7 flex items-center justify-center hover:bg-[var(--app-base)]"
              (click)="closeSidePanel()">close</span>
      </div>
    </div>

    <!-- Season Info (above tabs) -->
    <div *ngIf="selectedSeasonData" class="px-5 py-2 border-b border-[var(--app-base)]">
      <div class="text-[12px] font-bold text-[var(--base-text-dark)] mb-1">Season: {{selectedSeasonData.name}}</div>
      <div class="flex items-center flex-wrap gap-x-1 text-[11px] text-[var(--tertiary-text)]">
        <span class="font-semibold">Date Created:</span> <span>{{selectedSeasonData.creationDate | date:'yyyy-MM-dd'}}</span>
        <span class="mx-1">|</span>
        <span class="font-semibold">Start:</span> <span>{{selectedSeasonData.startDate | date:'yyyy-MM-dd'}}</span>
        <span class="mx-1">|</span>
        <span class="font-semibold">End:</span> <span>{{selectedSeasonData.endDate | date:'yyyy-MM-dd'}}</span>
        <span class="mx-1">|</span>
        <span class="font-semibold">Fields:</span> <span>{{selectedSeasonData.totalFields}}</span>
      </div>
    </div>

    <!-- Panel Body: reuse edit-field-link-season component inline -->
    <div class="flex gap-0 px-5 border-b border-[var(--app-base)]">
      <button (click)="panelTab = 'field'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        [disabled]="cultivarSizeInvalid && panelTab !== 'field'"
        [title]="cultivarSizeInvalid && panelTab !== 'field' ? 'Fix the cultivar size first' : ''"
        [ngClass]="panelTab === 'field' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Field Data</button>
      <button (click)="panelTab = 'crop'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        [disabled]="cultivarSizeInvalid && panelTab !== 'crop'"
        [title]="cultivarSizeInvalid && panelTab !== 'crop' ? 'Fix the cultivar size first' : ''"
        [ngClass]="panelTab === 'crop' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Crop Detail</button>
      <button (click)="panelTab = 'cost'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
        [disabled]="cultivarSizeInvalid && panelTab !== 'cost'"
        [title]="cultivarSizeInvalid && panelTab !== 'cost' ? 'Fix the cultivar size first' : ''"
        [ngClass]="panelTab === 'cost' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Cost</button>
    </div>

    <div class="flex-1 overflow-y-auto" *ngIf="selectedFieldId">
      <app-edit-field-link-season [fieldIdInput]="selectedFieldId" [inlineMode]="true" [panelTab]="panelTab" (seasonDataLoaded)="onSeasonDataLoaded($event)" (fieldNameUpdated)="onFieldNameUpdated($event)"></app-edit-field-link-season>
    </div>

    <!-- Panel Footer -->
    <div class="px-5 py-3 border-t border-[var(--app-base)] flex justify-end">
      <button (click)="saveFieldFromPanel()"
        [disabled]="cultivarSizeInvalid"
        [title]="cultivarSizeInvalid ? 'Fix the cultivar size before saving' : ''"
        class="py-2 px-5 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer hover:opacity-90 transition-all disabled:opacity-40 disabled:cursor-not-allowed">
        UPDATE DETAILS
      </button>
    </div>
  </div>
</div><!-- end relative container -->
